import { attempt as i } from "./contact-channels54.js";
import o from "./contact-channels78.js";
import { isSupportedCountry as u, getCountryCallingCode as d } from "./contact-channels79.js";
import s from "./contact-channels80.js";
import l from "./contact-channels81.js";
import c from "./contact-channels82.js";
function m(e, t) {
  return t ? l(e, t, o) : l(e, o);
}
function P(e) {
  return u(e, o);
}
function f(e) {
  return d(e, o);
}
function S(e, t) {
  return c(e, t, o);
}
class $ extends s {
  constructor(t) {
    super(t, o);
  }
}
const v = (e) => {
  const t = [];
  return e != null && e.length && e.forEach((r) => {
    const a = {
      startDay: r.weekday,
      endDay: r.weekday,
      startTime: r.startTime,
      endTime: r.endTime
    }, n = t[t.length - 1];
    n && n.startTime === r.startTime && n.endTime === r.endTime ? n.endDay = r.weekday : t.push(a);
  }), t;
}, _ = (e, t) => {
  const { data: r, error: a } = i(() => m(e, t));
  return a ? {
    isValid: !1,
    message: "call_me.form.fields.phone_number.errors.invalid_format"
  } : {
    isValid: (r == null ? void 0 : r.isValid()) || !1,
    phoneNumber: r == null ? void 0 : r.number,
    message: "call_me.form.fields.phone_number.errors.invalid_format"
  };
}, N = (e, t) => {
  var n;
  const { data: r, error: a } = i(() => m(e));
  return a ? !1 : (r == null ? void 0 : r.countryCallingCode) === ((n = t == null ? void 0 : t.trim()) == null ? void 0 : n.replace("+", ""));
}, w = (e) => {
  const { data: t, error: r } = i(() => f(e));
  return r ? (console.warn(`Error getting calling code for ${e}: ${r}`), "1") : t;
};
export {
  $ as AsYouType,
  v as formatPhoneSchedules,
  w as getCallingCode,
  f as getCountryCallingCode,
  N as isSameCountryPhone,
  P as isSupportedCountry,
  m as parsePhoneNumber,
  _ as validatePhoneNumber,
  S as validatePhoneNumberLength
};
//# sourceMappingURL=contact-channels47.js.map
